import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { api, environment } from "../environments/environment";
import { Router } from "@angular/router";
import { mockData } from "../mockData";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private transloco: TranslocoService,private router:Router) {}

  isUniversalLoaded = false

  ngOnInit(): void {
    
  }

}
